import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { TranslateDirective } from '@ngx-translate/core'

export type AddSpeakerDialogData = {
  attendeeNames: string[]
}

@Component({
  selector: 'app-add-speaker-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    TranslateDirective,
    MatDialogClose,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatAutocompleteModule,
  ],
  templateUrl: './add-speaker-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './add-speaker-dialog.component.scss',
})
export class AddSpeakerDialogComponent {
  data: AddSpeakerDialogData = inject(MAT_DIALOG_DATA)
  speakerName = ''

  get filteredAttendeeNames(): string[] {
    const filterValue = this.speakerName.toLowerCase()
    return this.data.attendeeNames.filter((name) => name.toLowerCase().includes(filterValue))
  }
}
